import Base from "../../Components/Layout/Base";
import Footer from "../../Components/Layout/Footer";
import Navigation from "../../Components/Layout/Navigation";
import { useEffect } from "react";
const RefundPolicy = () => {
    useEffect(()=>{
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    },[])
    return(
        <Base>
        <div className="wrapper">
            <div className="t-n-c-block">
          <div className="heading">
            <div className="head">
              <h1 className="title">Refund Policy</h1>
            </div>
            <div className="date">Last Updated: April 24, 2025</div>
          </div>

          <div className="policy-terms " style={{ marginBottom: '6rem' }}>
          <div className="text-block">
          <div className="text">masterNAUKRI by Kidex's refund policy for online subscriptions</div>
            <p className="paragraph ">
At masterNAUKRI by Kidex, we strive to provide exceptional programs for students aimed at their holistic development. By keeping your subscription active, you can continue to support your holistic development that helps to develop important skills and knowledge.

Once you subscribe and make the required payment for any online subscriptions, it shall be final and there cannot be any changes or modifications to the same and neither will there be any refund. However, paid access continues until the ongoing subscription period ends. Additionally, your progress data remains intact within the masterNAUKRI by Kidex account until the student initiates the account deletion process from their end.

If you still need additional support, you can reach out to our support team by writing an email to <strong>info@kid-ex.com</strong>
            </p>
        </div>
        </div>
        </div>
        </div>
        </Base>
    )
}

export default RefundPolicy;